// src/propertyManagement/pages/Dashboard.jsx
import React, { useState } from 'react';
import { Link, useNavigate }             from 'react-router-dom';
import {
  PieChart, Pie, Cell,
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer
} from 'recharts';

export default function Dashboard() {
    const [hoveredRow, setHoveredRow] = useState(null);
  const [taskTab, setTaskTab]       = useState('incoming');
    const [insuranceTab, setInsuranceTab]     = useState('Expired');

  const [overdueTab, setOverdueTab] = useState('mine');
  const [leasesTab, setLeasesTab]   = useState('0–30');
    const leaseTabs                          = ['0–30','31–60','61–90','All'];
  const insuranceTabs                      = ['Expired','0–30','31–60','61–90','All'];
 const [applicationsTab, setApplicationsTab] = useState('Active Applicants');
   // at the top of Dashboard()
  const [activityFilter, setActivityFilter] = useState('Last 7 days');
// derive “Good morning/afternoon/evening”
const hours   = new Date().getHours();
const greeting =
  hours < 12 ? 'morning'
: hours < 18 ? 'afternoon'
: 'evening';

// total of all outstanding balances

  const activityData = [
    {
      type: 'Applicant',
      date: 'Today — 7/16',
      desc: 'Rental application received from Andria Clark for 818 Laurel Street, 1',
      user: 'Anonymous User'
    },
    {
      type: 'Rental unit',
      date: 'Today — 7/16',
      desc: 'The unit was delisted and no longer displayed as available on the company’s public site at 82 W Falls Rd, TN 38109, 1',
      user: 'Nhicole Claridad'
    },
    {
      type: 'Applicant',
      date: 'Yesterday — 7/15',
      desc: 'Rental application received from Tomur Mason for 1328 Lambert Street, 1',
      user: 'Anonymous User'
    },
    // …add as many as you like…
  ];
  const applicationsTabs = ['Active Applicants','New','Undecided','Approved'];

  // ➤ Dummy data for each tab
  const applicationsData = {
    'Active Applicants': [
      { name: 'New applicants',      count: 0 },
      { name: 'Screening stage',     count: 2 },
      { name: 'Application stage',   count: 2 }
    ],
    'New': [
      { name: 'New applicants',      count: 5 }
    ],
    'Undecided': [
      { name: 'In review',           count: 3 },
      { name: 'Awaiting decision',   count: 2 }
    ],
    'Approved': [
      { name: 'Approved this month', count: 4 }
    ]
  };

  // ➤ derive the currently-visible data & total
  const currentApplicationsData = applicationsData[applicationsTab];
  const totalApplications = currentApplicationsData.reduce((sum, i) => sum + i.count, 0);


  // — dummy data —
  const outstandingBalances = [
    { address: '3048 Saint Cloud Pl, Memphis, TN', balance: 28050.00 },
    { address: '750 Hilton Street - 1',           balance: 5679.67  },
    { address: '2950 Lake Park Road - 1',          balance: 5627.75  },
    { address: '1262 Latham Street - 1',           balance: 4830.00  },
    { address: '2136 Bennett Avenue - 1',          balance: 4761.30  },
  ];

  const tasksData = [
    { id: 1, title: 'Screen application for 2136 Bennett', date: '2025-07-10' },
    { id: 2, title: 'Order new locks for 750 Hilton',      date: '2025-07-12' }
  ];

  const overdueTasksData = [
    { id: 101, title: 'Follow up rent reminder: Lake Park', daysOverdue: 3 }
  ];

  const insuranceData = [
    { name: 'MSI policy',    value: 10,  color: '#8884d8' },
    { name: 'Third Party',   value: 13,  color: '#82ca9d' },
    { name: 'Not insured',   value: 152, color: '#ff8042' }
  ];

  // For Expiring Leases tabbed data
  const expiringLeasesByTab = {
    '0–30': [
      { name: 'Not started', count: 2 },
      { name: 'Offers',      count: 5 },
      { name: 'Renewals',    count: 3 },
      { name: 'Move-outs',   count: 0 }
    ],
    '31–60': [
      { name: 'Not started', count: 1 },
      { name: 'Offers',      count: 2 },
      { name: 'Renewals',    count: 1 },
      { name: 'Move-outs',   count: 0 }
    ],
    '61–90': [
      { name: 'Not started', count: 3 },
      { name: 'Offers',      count: 11 },
      { name: 'Renewals',    count: 0 },
      { name: 'Move-outs',   count: 0 }
    ],
    All: [
      { name: 'Not started', count: 6 },
      { name: 'Offers',      count: 18 },
      { name: 'Renewals',    count: 4 },
      { name: 'Move-outs',   count: 0 }
    ]
  };

  // For Expiring Renters Insurance tabbed data
  const expiringInsuranceByTab = {
    Expired: [
      { name: 'Shanna Pierson',    daysAgo: 1160 },
      { name: 'Derkisha Jones*',   daysAgo:  850 },
      { name: 'Porscha Williams**',daysAgo:  837 },
      { name: 'Roslin Charles*',   daysAgo:  733 },
      { name: 'Alexandra Haywood**',daysAgo: 676 }
    ],
    '0–30': [
      { name: 'Jordan Smith',      daysAgo:   5 },
      { name: 'Alex Lee',          daysAgo:  12 },
      { name: 'Taylor Nguyen',     daysAgo:  22 }
    ],
    '31–60': [
      { name: 'Casey Patel',       daysAgo:  45 },
      { name: 'Morgan Brown',      daysAgo:  50 }
    ],
    '61–90': [
      { name: 'Jamie Chen',        daysAgo:  75 },
      { name: 'Riley Jackson',     daysAgo:  88 }
    ],
  };

  const listingData = [
    { name: 'Vacant - unlisted',   value: 47  },
    { name: 'Vacant - listed',     value: 17  },
    { name: 'Occupied - unlisted', value: 158 },
    { name: 'Occupied - listed',   value: 6   }
  ];

  // local tabs

    const totalInsurance = insuranceData.reduce((sum,e)=>sum+e.value, 0);
  const expiringLeasesData = expiringLeasesByTab[leasesTab];
const totalOutstanding = outstandingBalances
  .reduce((sum, o) => sum + o.balance, 0);
  // derive insurance list for current tab
  let expiringInsuranceList = insuranceTab === 'All'
    ? Object.values(expiringInsuranceByTab).flat()
    : expiringInsuranceByTab[insuranceTab];
const navigate = useNavigate();

  return (<>

  <div style={{ marginBottom: '1.5rem', fontSize: '1.2rem' }}>
      Good {greeting}, Jackson!
    </div>
  <div style={styles.container}>

      {/* Outstanding Balances */}
    <div style={styles.card}>
    <h3 style={styles.title}>Outstanding Balances — Rentals</h3>
      <div style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>
    ${totalOutstanding.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}
  </div>
  <div style={{ fontSize: '0.9rem', color: '#555', marginBottom: '1rem' }}>
    Outstanding balances
  </div>
    <div style={styles.scrollContainer}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Property</th>
            <th style={styles.th}>Balance</th>
          </tr>
        </thead>
        <tbody>
          {outstandingBalances.slice(0,5).map((o,i)=>(
            <tr
              key={i}
              onMouseEnter={()=>setHoveredRow(i)}
              onMouseLeave={()=>setHoveredRow(null)}
              onClick={() =>
                navigate(
                  `/pm/properties/${encodeURIComponent(o.address)}`,
                  { state: { address: o.address, balance: o.balance } }
                )
              }
              style={{
                ...styles.row,
                ...(hoveredRow===i ? styles.rowHover : {}),
                cursor: 'pointer',
              }}
            >
              <td style={styles.tdLeft}>{o.address}</td>
              <td style={styles.tdRight}>${o.balance.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div style={styles.footer}>
      Showing 5 of {outstandingBalances.length} |
      <Link to="/pm/balances" style={styles.link}>View all →</Link>
    </div>
  </div>

      {/* Tasks */}
      <div style={styles.card}>
        <h3 style={styles.title}>Tasks</h3>
        <div style={styles.tabContainer}>
          <button
            style={taskTab==='incoming' ? styles.activeTab : styles.tab}
            onClick={()=>setTaskTab('incoming')}
          >Incoming</button>
          <button
            style={taskTab==='assigned' ? styles.activeTab : styles.tab}
            onClick={()=>setTaskTab('assigned')}
          >Assigned</button>
        </div>
        <div style={styles.scrollContainer}>
          {taskTab==='incoming' ? (
            tasksData.length===0
              ? <p style={styles.empty}>No incoming requests.</p>
              : <ul style={styles.list}>
                  {tasksData.map(t=>(
                    <li key={t.id} style={styles.listItem}>
                      {t.title} <small>({t.date})</small>
                    </li>
                  ))}
                </ul>
          ) : (
            <p style={styles.empty}>No tasks assigned to you.</p>
          )}
        </div>
        <div style={styles.footer}>
          <Link to="/pm/tasks" style={styles.link}>View all →</Link>
        </div>
      </div>

      {/* Renters Insurance */}
    <div style={styles.card}>
        <h3 style={styles.title}>Renters Insurance</h3>
        <ResponsiveContainer width="100%" height={160}>
          <PieChart>
            <Pie
              data={insuranceData}
              dataKey="value"
              nameKey="name"
              innerRadius={50}
              outerRadius={70}
              labelLine={false}
            >
              {insuranceData.map((e,i)=>(
                <Cell key={i} fill={e.color}/>
              ))}
            </Pie>
            {/* center total */}
            <text
              x="50%" y="50%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={styles.totalLabel}
            >
              {totalInsurance}
            </text>
          </PieChart>
        </ResponsiveContainer>
        <ul style={styles.legend}>
          {insuranceData.map((e,i)=>(
            <li key={i} style={styles.legendItem}>
              <span style={{ ...styles.legendBullet, backgroundColor: e.color }} />
              {e.name}: {e.value}
            </li>
          ))}
        </ul>
        <div style={styles.footer}>
          <Link to="/pm/insurance" style={styles.link}>View all →</Link>
        </div>
      </div>

      {/* Overdue Tasks */}
      <div style={styles.card}>
        <h3 style={styles.title}>Overdue Tasks</h3>
        <div style={styles.tabContainer}>
          <button
            style={overdueTab==='mine' ? styles.activeTab : styles.tab}
            onClick={()=>setOverdueTab('mine')}
          >Mine</button>
          <button
            style={overdueTab==='all' ? styles.activeTab : styles.tab}
            onClick={()=>setOverdueTab('all')}
          >All</button>
        </div>
        <div style={styles.scrollContainer}>
          {overdueTab==='mine' ? (
            overdueTasksData.length===0
              ? <p style={styles.empty}>No overdue tasks.</p>
              : <ul style={styles.list}>
                  {overdueTasksData.map(t=>(
                    <li key={t.id} style={styles.listItem}>
                      {t.title} (<strong>{t.daysOverdue}d</strong> overdue)
                    </li>
                  ))}
                </ul>
          ) : (
            <p style={styles.empty}>No overdue tasks.</p>
          )}
        </div>
        <div style={styles.footer}>
          <Link to="/pm/tasks" style={styles.link}>View all →</Link>
        </div>
      </div>

      {/* Expiring Leases */}
      <div style={styles.card}>
        <h3 style={styles.title}>Expiring Leases</h3>
        <div style={styles.tabContainer}>
          {leaseTabs.map(label => (
            <button
              key={label}
              onClick={() => setLeasesTab(label)}
              style={leasesTab === label ? styles.activeTab : styles.tab}
            >
              {label}
            </button>
          ))}
        </div>
        <ResponsiveContainer width="100%" height={140}>
          <BarChart data={expiringLeasesData}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey="name"/>
            <YAxis/>
            <Tooltip/>
            <Bar dataKey="count" fill="#8884d8"/>
          </BarChart>
        </ResponsiveContainer>
        <div style={styles.footer}>
          <Link to="/pm/leases" style={styles.link}>View all →</Link>
        </div>
      </div>

      {/* Expiring Renters Insurance */}
      <div style={styles.card}>
        <h3 style={styles.title}>Expiring Renters Insurance</h3>
        <div style={styles.tabContainer}>
          {insuranceTabs.map(label => (
            <button
              key={label}
              onClick={() => setInsuranceTab(label)}
              style={insuranceTab === label ? styles.activeTab2 : styles.tab2}
            >
              {label}
            </button>
          ))}
        </div>
        <div style={styles.scrollContainer}>
          <ul style={styles.list}>
            {expiringInsuranceList.length === 0 && (
              <li style={styles.empty}>No expiring insurance found.</li>
            )}
            {expiringInsuranceList.map((item, i) => (
              <li key={i} style={styles.listItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{item.name}</span>
                  <span style={{ color: '#777' }}>{item.daysAgo} days ago</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div style={styles.footer}>
          <Link to="/pm/insurance" style={styles.link}>View all →</Link>
        </div>
      </div>

      {/* Rental Listings */}
       <div style={styles.card}>
        <h3 style={styles.title}>Rental Listings</h3>
        <ResponsiveContainer width="100%" height={140}>
          <PieChart>
            <Pie
              data={listingData}
              dataKey="value"
              nameKey="name"
              innerRadius={40}
              outerRadius={60}
              label
            >
              {listingData.map((_, i) => (
                <Cell key={i} fill={styles.colors[i % styles.colors.length]}/>
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <ul style={styles.legend}>
          {listingData.map((e,i) => (
            <li key={i} style={styles.legendItem}>
              <span style={{ 
                ...styles.legendBullet, 
                backgroundColor: styles.colors[i] 
              }} />
              {e.name}: {e.value}
            </li>
          ))}
        </ul>
        <div style={styles.footer}>
          <Link to="/pm/listings" style={styles.link}>View all →</Link>
        </div>
      </div>
      <div style={styles.card}>
        <h3 style={styles.title}>Rental Applications</h3>

        {/* tabs */}
        <div style={styles.tabContainer}>
          {applicationsTabs.map(label => (
            <button
              key={label}
              onClick={() => setApplicationsTab(label)}
              style={applicationsTab === label ? styles.activeTab : styles.tab}
            >
              {label}
            </button>
          ))}
        </div>

        {/* horizontal bar chart */}
<ResponsiveContainer width="100%" height={140}>
  <BarChart layout="vertical" data={currentApplicationsData}>
    <CartesianGrid strokeDasharray="3 3" />

    <XAxis 
      type="number" 
      tick={{ fontSize: 14, fill: '#555' }} 
    />

    <YAxis 
      type="category" 
      dataKey="name" 
      width={90}               // shrink if you like
      tick={{ fontSize: 17, fill: '#555' }} 
    />

    <Tooltip />

    <Bar dataKey="count" fill="#82ca9d" />
  </BarChart>
</ResponsiveContainer>

        {/* total count */}
        <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '0.5rem' }}>
          {totalApplications} total
        </div>

        {/* footer link */}
        <div style={styles.footer}>
          <Link to="/pm/applications" style={styles.link}>View all →</Link>
        </div>
      </div>
            {/* Recent Activity */}
 <div style={{ ...styles.card, maxHeight: 500 }}>
        <h3 style={styles.title}>Recent Activity</h3>

        {/* filter dropdown mimic */}
        <div style={styles.filter} onClick={() => {/* hook up a real dropdown if you like */}}>
          <span>{activityFilter} — 7/10 - 7/16</span>
          <span style={styles.arrow}>▾</span>
        </div>

        {/* scrollable list */}
      <div style={styles.activityScroll}>
          {activityData.map((item, i) => (
            <div key={i} style={styles.activityItem}>
              <div style={styles.activityHeader}>
                <span style={styles.activityType}>{item.type}</span>
                <span style={styles.activityDate}>{item.date}</span>
              </div>
              <p style={styles.activityDesc}>{item.desc}</p>
              <small style={styles.activityFooter}>
                Completed by {item.user}
              </small>
            </div>
          ))}
        </div>
      </div>
    </div>
  </>
    

  );
}

const styles = {
  // colors for pies/bars
  colors: ['#0088FE','#00C49F','#FFBB28','#FF8042'],

  // overall dashboard grid
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',  // 3 cards per row
    gap: '1.5rem',
    padding: '1.5rem'
  },

  // individual card
  card: {
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 300
  },

  // card title
  title: {
    margin: 0,
    marginBottom: '1rem',
    fontSize: '1.2rem'
  },

  // scrollable area for long tables/lists
  scrollContainer: {
    flex: 1,
    overflowY: 'auto',
    marginBottom: '1rem'
  },

  // table styles
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  th: {
    textAlign: 'left',
    borderBottom: '1px solid #ddd',
    paddingBottom: '0.5rem'
  },
  row: {
    cursor: 'pointer',
    transition: 'background 0.2s'
  },
  rowHover: {
    backgroundColor: '#f0f8ff'
  },
  tdLeft: {
    textAlign: 'left',
    padding: '0.5rem 0'
  },
  tdRight: {
    textAlign: 'right',
    padding: '0.5rem 0'
  },

  // generic list
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  listItem: {
    padding: '0.5rem 0',
    borderBottom: '1px solid #f0f0f0',
    cursor: 'pointer'
  },

  // legend for pies
  legend: {
    listStyle: 'none',
    padding: 0,
    margin: '1rem 0'
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.95rem',
    marginBottom: '0.5rem'
  },
  legendBullet: {
    display: 'inline-block',
    width: 12,
    height: 12,
    marginRight: 8,
    borderRadius: 2
  },

  // donut chart center label
  totalLabel: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    fill: '#333'
  },

  // tabs
  tabContainer: {
    display: 'flex',
    marginBottom: '1rem'
  },
  tab: {
    flex: 1,
    padding: '0.5rem',
    background: '#fafafa',
    border: '1px solid #ddd',
    cursor: 'pointer',
    borderRadius: 8,
    marginRight: '0.5rem',
    textAlign: 'center'
  },
  activeTab: {
    flex: 1,
    padding: '0.5rem',
    background: '#e6f7ff',
    border: '1px solid #007bff',
    cursor: 'pointer',
    borderRadius: 8,
    marginRight: '0.5rem',
    textAlign: 'center'
  },
  tab2: {
    flex: 1,
    padding: '0.5rem',
    background: '#fafafa',
    border: '1px solid #ddd',
    cursor: 'pointer',
    borderRadius: 8,
    marginRight: '0.5rem',
    textAlign: 'center',
    fontSize: 13
  },
  activeTab2: {
    flex: 1,
    padding: '0.5rem',
    background: '#e6f7ff',
    border: '1px solid #007bff',
    cursor: 'pointer',
    borderRadius: 8,
    marginRight: '0.5rem',
    textAlign: 'center',
    fontSize: 13
  },

  // empty state messaging
  empty: {
    textAlign: 'center',
    color: '#777',
    padding: '1rem 0'
  },

  // card footer/link area
  footer: {
    marginTop: 'auto',
    fontSize: '0.9rem',
    textAlign: 'right'
  },
  link: {
    color: '#007bff',
    textDecoration: 'none',
    marginLeft: '0.25rem'
  },

  // Recent Activity styles
  filter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#fafafa',
    border: '1px solid #ddd',
    borderRadius: 8,
    padding: '0.5rem',
    marginBottom: '1rem',
    cursor: 'pointer'
  },
  arrow: {
    marginLeft: '0.5rem',
    fontSize: '0.8rem'
  },
  activityItem: {
    background: '#f9f9f9',
    border: '1px solid #eee',
    borderRadius: 8,
    padding: '0.75rem',
    marginBottom: '0.75rem'
  },
  activityHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.25rem'
  },
  activityType: {
    fontWeight: 'bold',
    color: '#007bff'
  },
  activityDate: {
    fontSize: '0.85rem',
    color: '#777'
  },
  activityDesc: {
    margin: '0.25rem 0',
    color: '#333'
  },
 activityScroll: {
   flex:      1,       // fill the rest of the card
   overflowY: 'auto'   // scroll internally
 },
  activityFooter: {
    fontSize: '0.8rem',
    color: '#555'
  }
};